import api, { apiService } from './api';

const exportLutService = {
  getAll: async () => {
    const response = await api.get('/export-luts');
    return response.data;
  },

  getApplicable: async (date) => {
    const query = date ? `?date=${encodeURIComponent(date)}` : '';
    const response = await api.get(`/export-luts/applicable${query}`);
    return response.data;
  },

  save: async (payload, id) => {
    const formData = new FormData();
    formData.append('lutArn', payload.lutArn || '');
    formData.append('filingDate', payload.filingDate || '');
    formData.append('financialYear', payload.financialYear || '');
    formData.append('status', payload.status || 'Active');
    formData.append('remarks', payload.remarks || '');
    if (payload.document) formData.append('document', payload.document);

    const response = id
      ? await api.put(`/export-luts/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      : await apiService.upload('/export-luts', formData);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`/export-luts/${id}`);
    return response.data;
  },

  downloadDocument: async (id, fileName) => {
    const response = await apiService.download(`/export-luts/${id}/document`);
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'lut-document';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default exportLutService;
